<template>
  <div class="card">
    <b-form-group label="Day of the week:" v-slot="{ ariaDescribedby }">
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="flavour-1"
      ></b-form-checkbox-group>
    </b-form-group>
    <b-form-timepicker
      placeholder="Choose a time"
      id="timepicker"
      size="sm"
      locale="en"
      class="mb-2"
      v-model="time"
    ></b-form-timepicker>
  </div>
</template>

<script>
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      cronExpression: "",
      time: "16:00:00",
      selected: [],
      options: [
        { text: "Sun", value: "0" },
        { text: "Mon", value: "1" },
        { text: "Tue", value: "2" },
        { text: "Wed", value: "3" },
        { text: "Thu", value: "4" },
        { text: "Fri", value: "5" },
        { text: "Sat", value: "6" }
      ],
      weeks: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
    };
  },
  created() {
    this.calcCron();
  },
  methods: {
    getCronExpression() {
      const weeksNumbers = this.selected;
      const timeArray = this.time.split(":");
      const selectedWeeks = [];
      for (const week of weeksNumbers) {
        const weekNew = parseInt(week);
        selectedWeeks.push(this.weeks[weekNew]);
      }
      const days = selectedWeeks.join(",");
      this.cronExpression = `${timeArray[1]} ${timeArray[0]} ? * ${days} *`;
    },
    calcCron() {
      if (this.value) {
        const timeArray = this.value.split(" ");
        if (timeArray.length === 6) {
          let minute = timeArray[0];
          if (minute.length === 1) {
            minute = "0" + minute;
          }
          let hour = timeArray[1];
          if (hour.length === 1) {
            hour = "0" + hour;
          }
          this.time = hour + ":" + minute + ":00";
          let weekArray;
          let selectedWeeks;
          if (timeArray[4]) {
            if (timeArray[4].includes("-")) {
              weekArray = timeArray[4].split("-");
              const rangeWeeks = weekArray.map(item => {
                return this.getWeekNumber(item);
              });
              selectedWeeks = this.getWeeks(rangeWeeks[0], rangeWeeks[1]);
            } else if (timeArray[4].includes(",")) {
              weekArray = timeArray[4].split(",");
              selectedWeeks = weekArray.map(item => {
                return this.getWeekNumber(item);
              });
            } else if (timeArray[4].includes("*")) {
              selectedWeeks = [0, 1, 2, 3, 4, 5, 6];
            } else {
              weekArray = timeArray[4].split(",");
              selectedWeeks = weekArray.map(item => {
                return this.getWeekNumber(item);
              });
            }
          }

          if (selectedWeeks) {
            this.selected = selectedWeeks;
          }
        }
      }
    },
    getWeeks(weekBegin, weekEnd) {
      const weeks = [];
      for (let index = weekBegin; index <= weekEnd; index++) {
        weeks.push(index);
      }
      return weeks;
    },
    getWeekNumber(week) {
      return this.options.find(t => {
        return t.text.toLowerCase() === week.toLowerCase();
      }).value;
    }
  },
  watch: {
    time() {
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    selected() {
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    value() {
      // this.calcCron();
    }
  }
};
</script>

<style lang="scss" scoped></style>
